import React from "react";
import News from "./News/News";
//import SliderTut from "./News/SliderTut";

const App = () => {
  return (
    <>
      <News />
    </>
  );
};

export default App;
